<template>
  <div class="products">
    <Banner :banner="banner" />
    <div class="container">
      <TypeMenu :menu="pro_type" />
      <div class="product-type flex">
        <div class="item"
        v-for="item in pro_type_list.child"
        :key="item.id"
        v-text="item.title"
        :class="{active:item.id===type2.currentID}"
        @click="type2.currentID=item.id"></div>
      </div>
      <div class="list flex flex-wrap">
        <div class="item" v-for="item in pro_list" :key="item.id" @click="gotoProduct(item.id)">
          <div class="title">{{item.title}}</div>
          <div class="img"><img :src="item.picurl" alt=""></div>
        </div>
      </div>
      <div class="more flex flex-align-center" @click="addProducts">
        <div class="txt">MORE</div>
        <i class="fa fa-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { pro_type } from '@/util/lang.js'
import { get_pro_list } from '@/util/lang.js'
import Banner from '@/components/Banner.vue'
import TypeMenu from '@/components/TypeMenu.vue'
import { mapActions, mapState } from 'vuex'
import { getProductsUrl,getProductstypeUrl2 } from '@/util/lang.js'
import Scrollbar from 'smooth-scrollbar';
import {get_column} from "../../util/lang";
export default {
  components: {
    Banner,
    TypeMenu
  },
  data() {
    return{
      pro_type:'',
      pro_type_list:'',
      type_list:'',
      pro_list:[],
      banner: {
        img: "/images/locals/productbanner.jpg",
        img_loading: "/images/locals_sm/productbanner.jpg",
        smallimg: "/images/locals_sm/productbanner.jpg",
        smallimg_loading: "/images/locals_sm/productbanner.jpg",
        content: {
          cn: "产品与方案",
          en: "Products"
        }
      },
      type2: {
        currentID: '',
        tabs: []
      },
      page: 1,
      products: [],
      totalPagers: 0
    }
  },
  mounted(){
    Scrollbar.initAll();
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      langProducttype: state => state.langProducttype,
      currenttid: state => state.currenttid
    }),
    firstProductType () {
      return this.langProducttype[this.lang][0]
    },
    type(){
      return this.langProducttype[this.lang]
    }
  },
  watch: {
    // 如果 firstProductType 有变化
    firstProductType: 'fetchRoute',
    // 如果路由有变化，会再次执行该方法
    '$route': 'fetchData',
    'type2.currentID': 'setProducts'
  },
  created () {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.fetchData()
    // console.log(this.langProducttype[this.lang])
  },
  beforeDestroy () {
    this.setCurrenttid('')
  },
  methods: {
    ...mapActions([
      'setCurrenttid'
    ]),
    fetchRoute (val) {
      if (val) {
        /* this.$router.push({
          name: 'products',
          params: { tid: val.ID }
        }) */
      }
    },
    fetchData () {
      this.pro_list = []
      const url = pro_type();
      this.$$axios.get(url).then(res => {
        res.data.forEach(item => {
          if (item.id == this.$route.params.tid) {
            this.pro_type_list = item
            this.type2.currentID = item.child[0].id
          }
        })
        this.pro_type = res.data
        this.banner.img = this.pro_type_list.picurl
        this.banner.smallimg = this.pro_type_list.picurl
      })
      // const url2 = get_pro_list(3);
      // this.$$axios.get(url2).then(res => {
      //   this.pro_list = res.data
      // })
      // let tid = this.$route.params.tid || ''
      // this.setCurrenttid(tid)
      // this.setType2()
      // this.setProducts()
    },
    async setProducts () {
      this.page = 1
      const url = get_pro_list(this.type2.currentID,this.page)
      this.$$axios.get(url).then(res => {
        // console.log(JSON.stringify(res.data.proarr.length))
        // console.log(res.data.pagershow.totalPagers)
        this.pro_list = res.data.pro
        this.totalPagers = res.data.page

      })
    },
    async addProducts () {
      // this.page++
      // console.log(this.page)
      if (this.page < this.totalPagers) {
        this.page++
        // console.log('更新数据')
        // this.loading = true
        const url = get_pro_list(this.type2.currentID,this.page)
        this.$$axios.get(url).then(res => {
          console.log(111)
          this.pro_list = this.pro_list.concat(res.data.pro)
          this.totalPagers = res.data.totalPagers
          // this.loading = false
        })
      }
    },
    setType2(){
      const url = getProductstypeUrl2(this.lang, this.currenttid)
      this.$$axios.get(url).then(res => {
        this.type2.tabs = res.data
        this.type2.currentID = this.$route.query.tid2 || res.data[0].id
      })
    },
    gotoProduct (id) {
      this.$router.push({
        name: 'product',
        params: {
          tid: this.currenttid,
          id
        }
      })
    }
  }
}
</script>

<style scoped>
.products .container{
  max-width: 1500px;
  margin: 0 auto;
  padding: 50px 0;
}
.products .container .product-type{
  flex-wrap: wrap;
  margin-top: 35px;
}
.products .container .product-type .item{
  width: 33.33%;
  border: 1px solid #fff;
  font-size: 20px;
  color: #005598;
  text-align: center;
  cursor: pointer;
  transition: .3s;
  padding: 15px 0;
  background-color: #e8e8e8;
}
.products .container .product-type .item.active,.products .container .product-type .item:hover{
  background-color: #005598;
  color: #fff;
}
.products .container .list{
  margin-top: 70px;
}
.products .container .list .item{
  width: 22.2%;
  margin-right: 3.73%;
  margin-bottom: 45px;
  border: 1px solid #f0f0f0;
  padding: 20px;
  text-align: center;
  transition: 1s;
  cursor: pointer;
}
.products .container .list .item:nth-of-type(4n){
  margin-right: 0;
}
.products .container .list .item .title{
  font-size: 16px;
  color: #000;
  margin-bottom: 50px;
}
.products .container .list .item .img{
  overflow: hidden;
  padding: 20px;
}
.products .container .list .item img{
  display: block;
  width: 100%;
  transition: 1s;
}
.products .container .list .item:hover{
  border-color: #005598;
}
.products .container .list .item:hover img{
  transform: scale(1.1);
}
.products .container .more{
  padding: 12px 20px;
  border: 1px solid #004b94;
  color: #004b94;
  font-size: 16px;
  width: 266px;
  margin: 60px auto 0;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: .3s;
  justify-content: center;
}
.products .container .more::before{
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background-color: #004b94;
    transition: .3s;
    border-radius: 0 50px 50px 0;
    border-right: 50px solid #004b94;
    margin-left: -50px;
    z-index: -1;
}
.products .container .more:hover::before{
    left: 0;
    margin-left: 0;
}
.products .container .more:hover{
  color: #fff;
}
.products .container .more .txt{
  margin-right: 50px;
}
@media (max-width: 1600px){
  .products .container {
    width: 90%;
  }
}
@media (max-width: 768px){
  .products .container .product-type .item{
    font-size: 14px;
    width: 50%;
    padding: 15px 10px;
  }
  .products .container .list{
    padding: 0 20px;
  }
  .products .container .list .item{
    width: 49%;
    margin-right: 2%;
    padding-left: 0;
    padding-right: 0;
  }
  .products .container .list .item:nth-of-type(4n){
    margin-right: 2%;
  }
  .products .container .list .item:nth-of-type(2n){
    margin-right: 0;
  }
  .products .container .list {
    padding: 0;
    margin-top: 30px;
  }
  .products .container .list .item .title {
    padding: 0 10px;
  }
}
</style>


